import { render, staticRenderFns } from "./often-win-rank.vue?vue&type=template&id=59509f94&scoped=true&"
import script from "./often-win-rank.vue?vue&type=script&lang=js&"
export * from "./often-win-rank.vue?vue&type=script&lang=js&"
import style0 from "./often-win-rank.vue?vue&type=style&index=0&id=59509f94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59509f94",
  null
  
)

export default component.exports